<div class="">
	<div class="upload-action-box">
		<div style="position: relative;">
			<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" [multiple]="false">
				<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
					<div class="text-center w-100" (click)="openFileSelector()" role="button">
						<button [id]="'file'+compId" style="display: none;">Browse Files</button>
						<label [for]="'file'+compId">
							<mat-icon style="font-size: 48px;width: 48px;height: 48px;">cloud_upload</mat-icon>
						</label>
						<div>
							<p style="color: #A9B8BF">Drag and drop a file here, or click to browse</p>
							<p>PDF,DOCX,XLSX up to 10MB</p>
						</div>
					</div>
				</ng-template>
			</ngx-file-drop>

			<!-- disabled box by condition -->
			<div class="dropzone" style="position: absolute;top: 0px; opacity: 0.5;" *ngIf="false" 
				(click)="validateUpload([])" 
				(onFileDrop)="validateUpload([]);"
			></div>
		</div>
		<hr>
		<!-- <span style="color: #EA1A47;">Maximum upload limit is {{appConfig.maxFileCount}} {{appConfig.maxFileCount==1?"file":"file(s)"}}.</span> -->
		<div class="row my-2" *ngFor="let item of uploadSummary">
			<div class="col-sm-12">
				<div class="d-flex">
					<span *ngIf="checkViewerRoles(item)" (click)="viewDocument(item)" class="cursor-pointer">{{ item.name }}</span>
					<div class="ms-2 d-none">
						<mat-icon (click)="removeuploaded(item)" class="cursor-pointer">delete</mat-icon>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>